import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'lyceo-ui-secondary-menu-item',
  templateUrl: './secondary-menu-item.component.html',
  styleUrls: ['./secondary-menu-item.component.scss'],
  imports: [RouterLink, RouterLinkActive, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecondaryMenuItemComponent {
  public readonly link: InputSignal<undefined | string[]> = input();
}
